import { Routes } from "@angular/router";

export const content: Routes = [
  {
    path: "dashboard",
    loadChildren: () =>
      import("../../component/dashboard/dashboard.module").then(
        (m) => m.DashboardModule
      ),
  },
  {
    path: "apps",
    loadChildren: () =>
      import("../../component/apps/apps.module").then((m) => m.AppsModule),
  },
  {
    path: "components",
    loadChildren: () =>
      import("../../component/components/components.module").then(
        (m) => m.ComponentsModule
      ),
  },
  {
    path: "elements",
    loadChildren: () =>
      import("../../component/elements/elements.module").then(
        (m) => m.ElementsModule
      ),
  },
  {
    path: "advanced-ui",
    loadChildren: () =>
      import("../../component/advanced-ui/advanced-ui.module").then(
        (m) => m.AdvancedUiModule
      ),
  },
  {
    path: "icons",
    loadChildren: () =>
      import("../../component/icons/icons.module").then((m) => m.IconsModule),
  },
  {
    path: "pages",
    loadChildren: () =>
      import("../../component/pages/pages.module").then((m) => m.PagesModule),
  },
  {
    path: "e-commerce",
    loadChildren: () =>
      import("../../component/e-commerce/e-commerce.module").then(
        (m) => m.ECommerceModule
      ),
  },
];
